<ion-button fill="clear" (click)="onToggle()" [disabled]="disabled">
  <fa-icon [icon]="faPlus" class="toggle-icon toggle-icon__off" *ngIf="!toggled"></fa-icon>
  <fa-icon [icon]="faCheck" class="toggle-icon toggle-icon__on" *ngIf="toggled"></fa-icon>
</ion-button>
